import React from 'react';
import GeneralStatus from '../../GeneralStatus';

/**
 * Mobile Opponent Avatars (General and Advisor) Component
 * Positioned at top-center of the screen
 */
export const MobileOpponentAvatars = ({
  opponent,
  opponentGeneral,
  opponentAdvisor,
  opponentUsername,
  opponentDamageFlash,
  avatars,
  yourTurn,
  attackMode,
  selectedAttacker,
  attackGeneral,
  getOpponentAvatarImage,
  getDamageFlashStyles,
  shouldMirrorOpponentAvatar,
  calculateFactionFromStrategy,
  getTranslatedFactionName,
  activeGameState,
  activeUserId
}) => {
  return (
    <div 
      className="opponent-avatars-container-mobile"
      style={{
        position: "absolute",
        top: "5px",
        left: "50%",
        transform: "translateX(-50%) scale(0.5)",
        transformOrigin: "center top",
        display: "flex",
        gap: "5px",
        alignItems: "center",
        zIndex: 1000
      }}
      onClick={() => {
        if (yourTurn && attackMode && selectedAttacker) {
          attackGeneral(selectedAttacker.zone, selectedAttacker.idx);
        }
      }}
    >
      {/* Opponent General with Health Orb and Bar */}
      <div style={{ position: "relative" }} className="opponent-health-orb-container-mobile">
        <GeneralStatus
          health={opponent.health}
          intelligenceLeft={opponent.intelligence}
          intelligenceTotal={opponent.maxIntelligence ?? 8}
          barriersRemoved={opponent.barriersRemoved ?? []}
          damageFlash={opponentDamageFlash}
          compact={true}
          showIntelligence={false}
          factionName={calculateFactionFromStrategy(opponent.strategy)}
          translatedFactionName={getTranslatedFactionName(calculateFactionFromStrategy(opponent.strategy))}
          isActiveTurn={!yourTurn}
        />
        
        {/* Opponent Name */}
        {opponentUsername && (
          <div style={{
            position: "absolute",
            bottom: "-20px",
            left: "50%",
            transform: "translateX(-50%)",
            textAlign: "center",
            color: "white",
            fontSize: "11px",
            fontWeight: "bold",
            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.8)",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            padding: "2px 4px",
            borderRadius: "4px",
            whiteSpace: "nowrap",
            zIndex: 10001
          }}>
            {opponentUsername}
          </div>
        )}
        
        <img 
          src={getOpponentAvatarImage(opponentGeneral)} 
          alt="Opponent General"
          style={{ 
            width: "90px", 
            height: "90px", 
            objectFit: "contain",
            ...getDamageFlashStyles(opponentDamageFlash),
            transform: shouldMirrorOpponentAvatar(opponentGeneral, 'upper_middle', 'general', avatars) ? 'scaleX(-1)' : 'none'
          }} 
        />
      </div>
      
      {/* Opponent Advisor with Intel Orb and Bar */}
      <div style={{ position: "relative" }} className="opponent-intel-orb-container-mobile">
        <GeneralStatus
          health={opponent.health}
          intelligenceLeft={opponent.intelligence}
          intelligenceTotal={opponent.maxIntelligence ?? 8}
          barriersRemoved={opponent.barriersRemoved ?? []}
          damageFlash={opponentDamageFlash}
          compactIntelligence={true}
        />
        
        {/* Opponent Title */}
        <div style={{
          position: "absolute",
          bottom: "-20px",
          left: "50%",
          transform: "translateX(-50%)",
          textAlign: "center",
          color: "white",
          fontSize: "11px",
          fontWeight: "bold",
          textShadow: "1px 1px 2px rgba(0, 0, 0, 0.8)",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          padding: "2px 4px",
          borderRadius: "4px",
          whiteSpace: "nowrap",
          zIndex: 10001
        }}>
          {activeGameState?.opponentTitles?.[activeUserId] || 'The undecided'}
        </div>
        
        <img 
          src={getOpponentAvatarImage(opponentAdvisor)} 
          alt="Opponent Advisor" 
          style={{
            width: "90px", 
            height: "90px", 
            objectFit: "contain",
            transform: shouldMirrorOpponentAvatar(opponentAdvisor, 'upper_middle', 'advisor', avatars) ? 'scaleX(-1)' : 'none'
          }}
        />
      </div>
    </div>
  );
};

export default MobileOpponentAvatars;

